import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@/shared/antd-imports';
import { BRAND_NAME, SOURCE_CODE_URL, UPSTREAM_LICENSE, UPSTREAM_PROJECT_NAME } from '@/config/brand';

interface BrandAttributionProps {
  style?: React.CSSProperties;
}

/**
 * Footer line: honest upstream attribution plus the source-code link required by AGPL-3.0 §13
 * for software offered over a network.
 */
export const BrandAttribution: React.FC<BrandAttributionProps> = ({ style }) => {
  const { t } = useTranslation();

  return (
    <div style={{ textAlign: 'center', ...style }}>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {t('app.brandAttribution.basedOn', {
          defaultValue: '{{brand}} is based on {{upstream}} ({{license}})',
          brand: BRAND_NAME,
          upstream: UPSTREAM_PROJECT_NAME,
          license: UPSTREAM_LICENSE,
        })}
        {' · '}
        <Typography.Link
          href={SOURCE_CODE_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: 12 }}
        >
          {t('app.brandAttribution.sourceCode', { defaultValue: 'Source code' })}
        </Typography.Link>
      </Typography.Text>
    </div>
  );
};
